function SectionWrapper({ children }) {
  return <section>{children}</section>;
}

export default SectionWrapper;
